import {
  IsString,
  ValidateNested,
  IsDefined,
  IsIn,
  IsNumber,
  IsOptional,
  IsNotEmpty,
  Min,
  Max,
  Matches,
  ArrayMinSize,
} from 'class-validator';
import { Type } from 'class-transformer';

class GradientStopDto {
  @IsDefined()
  @IsNumber()
  @Min(0)
  @Max(1)
  position!: number;

  @IsDefined()
  @IsString()
  @IsNotEmpty()
  @Matches(/^#?([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/, {
    message: 'hexa must be a valid hex color (3, 6, or 8 digits, optional leading #)',
  })
  hexa!: string;
}

class GradientCenterPointDto {
  @IsNumber()
  @Min(0)
  @Max(100)
  x!: number;

  @IsNumber()
  @Min(0)
  @Max(100)
  y!: number;
}

class GradientShapeCoordsDto {
  @IsNumber()
  @Min(0)
  @Max(100)
  x!: number;

  @IsNumber()
  @Min(0)
  @Max(100)
  y!: number;
}

export class GradientDto {
  @IsDefined()
  @IsString()
  @IsIn(['Linear', 'Radial'])
  type!: 'Linear' | 'Radial';

  @IsOptional()
  @IsNumber()
  @Min(0)
  @Max(360)
  angle?: number;

  @IsOptional()
  @ValidateNested()
  @Type(() => GradientCenterPointDto)
  centerPoint?: GradientCenterPointDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => GradientShapeCoordsDto)
  shapeCoords?: GradientShapeCoordsDto;

  @IsDefined()
  @ValidateNested({ each: true })
  @ArrayMinSize(2, { message: 'A gradient must have at least 2 stops' })
  @Type(() => GradientStopDto)
  stops!: GradientStopDto[];
}
